import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "modal-content" }
const _hoisted_2 = { class: "flex gap-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isOpen)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "modal-overlay z-30",
        onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)), ["self"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _cache[3] || (_cache[3] = _createElementVNode("h1", { class: "text-lg font-bold text-center text-blue-600 pb-4" }, " Deseja realmente sair da Aplicação? ", -1)),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", {
              class: "bg-transparent hover:bg-blue-400 text-blue-700 font-semibold hover:text-white py-2 px-4 w-full text-sm border border-blue-500 hover:border-transparent rounded-xl",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
            }, " Cancelar "),
            _createElementVNode("button", {
              class: "btn-primary bg-blue-500 hover:bg-blue-700 border text-white font-semibold text-sm py-2 px-4 rounded-xl w-full",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
            }, " Confirmar ")
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}